import type { PlacesResponse, PlaceItem } from '@/types/Address';

class PlacesService {
  // Search places using the existing places API
  async searchPlaces(query: string) {
    if (!query || query.trim().length < 2) {
      return {
        data: ref([]),
        pending: ref(false),
        error: ref(null),
      };
    }

    try {
      const { $api } = useNuxtApp();
      console.log('Searching places with query:', query);
      
      const response = await $api<PlacesResponse>('/places', {
        method: 'GET',
        params: { input: query.trim() },
      });
      
      if (response.success && Array.isArray(response.data)) {
        // Ensure we return plain objects to avoid serialization issues
        const places = JSON.parse(JSON.stringify(response.data));
        return {
          data: ref(places),
          pending: ref(false),
          error: ref(null),
        };
      }
      
      throw createError({
        statusCode: response.http_status || 500,
        statusMessage: 'Failed to search places'
      });
    } catch (error) {
      console.error('Places API error:', error);
      return {
        data: ref([]),
        pending: ref(false),
        error: ref(error),
      };
    }
  }

  // Get place details by place_id
  async getPlaceDetails(placeId: string) {
    if (!placeId) {
      return {
        data: ref(null),
        pending: ref(false),
        error: ref('Place ID is required'),
      };
    }

    try {
      const { $api } = useNuxtApp();
      console.log('Getting place details for:', placeId);
      
      const response = await $api<{ data: PlaceItem }>(`/places/${placeId}`, {
        method: 'GET',
      });
      
      console.log('Place details response:', response);
      
      if (response.data) {
        return {
          data: ref(response.data),
          pending: ref(false),
          error: ref(null),
        };
      }
      
      throw createError({
        statusCode: 404,
        statusMessage: 'Place not found'
      });
    } catch (error) {
      console.error('Place details error:', error);
      return {
        data: ref(null),
        pending: ref(false),
        error: ref(error),
      };
    }
  }
}

const placesService = new PlacesService();
export default placesService; 